import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../header/headerDashboard';
import { Button } from 'react-bootstrap';

const Histories = () => {
    const [histories, setHistories] = useState([]);
    const [openPayments, setOpenPayments] = useState([]);

    const fetchHistories = () => {
        fetch(`${process.env.REACT_APP_API_URL}/histories/`, {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json',
            })
        })
            .then(async (res) => {
                if (res.status === 200) return res.json();
                throw await res.json();
            })
            .then((res) => {
                setHistories(res);
            }).catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        fetchHistories();
    }, []);

    const handlePaiement = () => {
        fetch(`${process.env.REACT_APP_API_URL}/histories/`, {
            method: 'POST',
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({
                status: 'Paiement',
                client: 'Paiement',
                pharmacy: 'Paiement'
            })
        })
            .then(async (res) => {
                if (res.status === 200) return res.json();
                throw await res.json();
            })
            .then(() => {
                fetchHistories();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const paymentIndexes = histories
        .map((h, index) => ({ ...h, index }))
        .filter(h => h.status === 'Paiement')
        .map(h => h.index);

    const lastPaymentIndex = paymentIndexes.length > 0 ? paymentIndexes[paymentIndexes.length - 1] : -1;
    const unpaidBeds = lastPaymentIndex !== -1 ? histories.slice(lastPaymentIndex + 1) : histories;

    const togglePayment = (index) => {
        setOpenPayments(openPayments.includes(index)
            ? openPayments.filter(i => i !== index)
            : [...openPayments, index]);
    };

    const formatDate = (date) => new Date(date).toLocaleDateString('fr-FR');

    const badgeStyle = (color, bg) => ({
        fontSize: 11,
        padding: '2px 8px',
        borderRadius: 12,
        backgroundColor: bg,
        color,
        border: `1px solid ${color}`,
        whiteSpace: 'nowrap',
    });

    const renderBed = (bed, key, { borderColor, backgroundColor, marginLeft = 0 }) => (
        <div
            key={key}
            style={{
                borderLeft: `4px solid ${borderColor}`,
                borderRadius: 8,
                padding: '10px 14px',
                marginBottom: 6,
                marginLeft,
                backgroundColor,
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                <span style={{ fontWeight: 'bold', fontSize: 14 }}>Lit #{bed.number}</span>
                <span style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                    <span style={bed.status === 'end'
                        ? badgeStyle('#c0392b', '#fde8e8')
                        : badgeStyle('#27ae60', '#e8fdf0')}
                    >
                        {bed.status}
                    </span>
                    {bed.status === 'start' && bed.mattress && (
                        <span style={badgeStyle('#2980b9', '#eaf3fb')}>
                            🛏️ matelas classe {bed.mattressClass || 2}
                        </span>
                    )}
                </span>
            </div>
            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                {bed.client}{bed.pharmacy ? ` · ${bed.pharmacy}` : ''} · {formatDate(bed.createdAt)}
            </div>
        </div>
    );

    return (
        <div style={{ width: '100%', overflowX: 'hidden' }}>
            <HeaderDashboard />

            <div style={{ padding: '8px', maxWidth: 900, margin: '0 auto' }} className="p-md-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h2 style={{ fontSize: 18, fontWeight: 'bold', margin: 0 }}>Historique</h2>
                    <Button variant="success" className="d-none d-md-inline-block" onClick={handlePaiement}>
                        💰 Paiement
                    </Button>
                </div>

                {/* Paiements avec leurs lits */}
                {paymentIndexes.map((paymentIndex, i) => {
                    const isOpen = openPayments.includes(paymentIndex);
                    const previousPaymentIndex = i > 0 ? paymentIndexes[i - 1] : -1;
                    const bedsBetweenPayments = histories.slice(previousPaymentIndex + 1, paymentIndex);

                    return (
                        <React.Fragment key={paymentIndex}>
                            {/* Carte paiement */}
                            <div
                                onClick={() => togglePayment(paymentIndex)}
                                style={{
                                    borderLeft: '4px solid #0d6efd',
                                    borderRadius: 8,
                                    padding: '12px 14px',
                                    marginBottom: 6,
                                    backgroundColor: '#e8f0fe',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                }}
                            >
                                <div>
                                    <span style={{ fontWeight: 'bold', color: '#0d6efd', fontSize: 14 }}>
                                        💳 Paiement
                                    </span>
                                    <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                                        {formatDate(histories[paymentIndex].createdAt)}
                                        {bedsBetweenPayments.length > 0 && ` · ${bedsBetweenPayments.length} lit(s)`}
                                    </div>
                                </div>
                                <span style={{ fontSize: 16 }}>{isOpen ? '▲' : '▼'}</span>
                            </div>

                            {/* Lits entre paiements (expanded) */}
                            {isOpen && bedsBetweenPayments.map((bed, j) => renderBed(bed, `bed-${j}`, {
                                borderColor: '#adb5bd',
                                backgroundColor: '#f8f9fa',
                                marginLeft: 12,
                            }))}
                        </React.Fragment>
                    );
                })}

                {/* Lits non payés */}
                {unpaidBeds.length > 0 && (
                    <>
                        <div style={{ fontSize: 13, fontWeight: 'bold', color: '#856404', margin: '12px 0 6px' }}>
                            Non payés ({unpaidBeds.length})
                        </div>
                        {unpaidBeds.map((bed, i) => renderBed(bed, i, {
                            borderColor: '#ffc107',
                            backgroundColor: '#fffbea',
                        }))}
                    </>
                )}

                <Button variant="success" className="w-100 mt-3 d-md-none" onClick={handlePaiement}>
                    💰 Paiement
                </Button>
            </div>
        </div>
    );
};

export default Histories;
